var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bindPhoneNum" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": _vm.headShow,
          "title-mb": _vm.titleArray[0]
        }
      }),
      _c(
        "div",
        { staticClass: "formClass" },
        [
          !_vm.bindInfo.isBind
            ? _c(
                "van-form",
                { staticClass: "findTwo", on: { submit: _vm.onSubmit } },
                [
                  _c("van-field", {
                    attrs: {
                      name: "isPhone",
                      label: "手机号",
                      rules: _vm.rules.mobileRules
                    },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0  16px 16px" },
                    attrs: {
                      maxlength: "6",
                      label: "短信验证码",
                      rules: _vm.rules.codeRules
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button",
                          fn: function() {
                            return [
                              !_vm.showTime
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#616edf",
                                        cursor: "pointer"
                                      },
                                      on: { click: _vm.getCode }
                                    },
                                    [_vm._v(_vm._s(_vm.timeMsg))]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#878787",
                                        cursor: "pointer"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.codeTime) + " S")]
                                  )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      895199067
                    ),
                    model: {
                      value: _vm.code,
                      callback: function($$v) {
                        _vm.code = $$v
                      },
                      expression: "code"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        padding: "0.2rem 0.4rem",
                        color: "#878787",
                        width: "7rem"
                      }
                    },
                    [_vm._v(" *如果一分钟内没有收到验证码请重新获取 ")]
                  ),
                  _c(
                    "van-checkbox",
                    {
                      staticClass: "checkbox",
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _vm._v("我已阅读并同意 "),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#626fdd" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.ltUserRule($event)
                            }
                          }
                        },
                        [_vm._v("《雷霆游戏用户隐私政策》")]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#626fdd" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.ltGameRule($event)
                            }
                          }
                        },
                        [_vm._v("《雷霆游戏用户协议》")]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            "native-type": "submit",
                            color: "#616edf"
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "success" },
                [
                  _c("img", {
                    attrs: {
                      src: require("assets/images/accountCenter/success@2x.png"),
                      alt: "",
                      srcset: ""
                    }
                  }),
                  _c("p", [_vm._v("您已成功认证手机，进行实名认证更安全")]),
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        block: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: { click: _vm.goRealName }
                    },
                    [_vm._v("实名认证")]
                  ),
                  _c("p", { on: { click: _vm.returnIndex } }, [
                    _vm._v("返回首页")
                  ])
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }